import { useMemo } from 'react';

import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';

import { getFiltersConfiguration } from 'app/modules/Purse/config/filters';
import useDataTableContext from 'app/components/DataTable/context/DataTableContext';

export const useFiltersConfiguration = () => {
  const intl = useIntl();
  const formik = useFormikContext();
  const {
    api: { apiResponse }
  } = useDataTableContext();
  const maxTotalAmount = useMemo(
    () => apiResponse?.meta?.maxTotalAmount || 0,
    [apiResponse?.meta?.maxTotalAmount]
  );

  const completeConfiguration = useMemo(
    () =>
      getFiltersConfiguration({
        intl,
        formik,
        maxTotalAmount
      }),
    [formik, intl, maxTotalAmount]
  );

  const getComponentFilter = (targetFilter) =>
    completeConfiguration.find((filter) => filter.value === targetFilter)
      .component;

  const getOptionsToSelect = () =>
    completeConfiguration.map(({ component, ...filter }) => filter);

  return {
    completeConfiguration,
    getComponentFilter,
    getOptionsToSelect
  };
};
